import { render, staticRenderFns } from "./pembatalanpencairandeposito.vue?vue&type=template&id=5f12c077&scoped=true"
import script from "./pembatalanpencairandeposito.vue?vue&type=script&lang=js"
export * from "./pembatalanpencairandeposito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12c077",
  null
  
)

export default component.exports